import * as firebase from 'firebase/app'
import { FireSQL } from 'firesql'
import 'firebase/auth'
import 'firebase/firestore'

//PRODUÇÃO
var firebaseConfig = {
  apiKey: "AIzaSyCiSAtAJMYPCme9DO40531PhIDw9JcDtPQ",
  authDomain: "pesquisa-wash-prod.firebaseapp.com",
  databaseURL: "https://pesquisa-wash-prod.firebaseio.com",
  projectId: "pesquisa-wash-prod",
  storageBucket: "pesquisa-wash-prod.appspot.com",
  messagingSenderId: "459424126191",
  appId: "1:459424126191:web:c2c3c70dc03a2d18dab71a"
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics(); -> é necessário?

const fireSQL = new FireSQL(firebase.firestore());

// utils
const db = firebase.firestore()
const auth = firebase.auth()

//colecoes
const usersCollection = db.collection('users')

export {
  db,
  auth,
  usersCollection,
  fireSQL
}
